import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Column, Row, TextField, Typography } from 'seagull';
import { withoutMinusSign } from './AiFilterChip.utils';
export const MinMaxFields = (param)=>{
    let { testIds, biPrefix, draft, minPlaceholder, maxPlaceholder, error, onChange, onSubmit } = param;
    const submitOnEnter = (event)=>{
        if (event.key === 'Enter') {
            event.preventDefault();
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        }
    };
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 8,
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                gap: 8,
                children: [
                    /*#__PURE__*/ _jsx(TextField, {
                        testId: testIds.AiFilterChipTestIds.MinField(),
                        bi: {
                            name: "".concat(biPrefix, "_edit_min")
                        },
                        fullWidth: true,
                        value: draft.min,
                        placeholder: minPlaceholder,
                        onChange: (event)=>onChange(_object_spread_props(_object_spread({}, draft), {
                                min: withoutMinusSign(event.target.value)
                            })),
                        inputProps: {
                            onKeyDown: submitOnEnter
                        },
                        autoFocus: true
                    }),
                    /*#__PURE__*/ _jsx(TextField, {
                        testId: testIds.AiFilterChipTestIds.MaxField(),
                        bi: {
                            name: "".concat(biPrefix, "_edit_max")
                        },
                        fullWidth: true,
                        value: draft.max,
                        placeholder: maxPlaceholder,
                        onChange: (event)=>onChange(_object_spread_props(_object_spread({}, draft), {
                                max: withoutMinusSign(event.target.value)
                            })),
                        inputProps: {
                            onKeyDown: submitOnEnter
                        }
                    })
                ]
            }),
            error != null && error !== '' && /*#__PURE__*/ _jsx(Typography, {
                testId: testIds.AiFilterChipTestIds.ValidationError(),
                skin: "error",
                variant: "paragraph2",
                children: error
            })
        ]
    });
};
